import { bool } from "prop-types";
import React from "react";
import CenterSide from "./centerside";
import HeaderContainer from "./header-container";
import LeftSide from "./leftside";
import RightSide from "./rightside";

class Header extends React.Component {
  static propTypes = {
    lightBackground: bool,
  };

  render() {
    let { lightBackground } = this.props;

    return (
      <HeaderContainer>
        <LeftSide lightBackground={lightBackground} />
        <CenterSide lightBackground={lightBackground} />
        <RightSide lightBackground={lightBackground} />
      </HeaderContainer>
    );
  }
}

export default Header;
